import {IPrMonteCarloDrawImperial, IWesleaResult,} from "@/modules/perRoad/interfaces/monteCarlo";
import {UnitSystem} from "@/interfaces/units";


/**
 * Extract the key horizontal strain values for the target layer.
 *
 * @param draws
 * @param wesleaConfigs
 * @param wesleaResults
 * @param layerNum
 * @param unitSystem
 */
export const getVerticalStrainValues = (
  // wesleaResults: IMonteCarloResultsObject[],
  draws: IPrMonteCarloDrawImperial[],
  layerNum: number,
  unitSystem = UnitSystem.Imperial,
) => {
  const verticalStrains: number[] = [];

  draws.forEach((draw) => {
    const drawResults = draw.wesleaResult;
    const wesleaConfig = draw.wesleaConfig;

    const layerBottom_in = draw.layers.filter((layer) => layer.layerNumber === layerNum).map((L) => L.depthOfLayerBottom_in)[0];

    const criticalLocationResults: IWesleaResult[] = [];
    if (wesleaConfig !== null) {
      wesleaConfig.criticallocations
        .forEach((critLoc, i) => {
          if (critLoc.l === layerNum && critLoc.z === layerBottom_in && drawResults && drawResults[i]) {
            criticalLocationResults.push(drawResults[i]);
          }
        });
    }

    const strains: number[] = [];
    criticalLocationResults.forEach((result) => {
      const s = result.normal_strain;
      strains.push(...[s.z]);
    });
    verticalStrains.push(Math.max(...strains));
  });
  return verticalStrains;
};
